import { render, staticRenderFns } from "./GalleryEditingAreaComponent.vue?vue&type=template&id=2b6c38ac&scoped=true&"
import script from "./GalleryEditingAreaComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryEditingAreaComponent.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEditingAreaComponent.vue?vue&type=style&index=0&id=2b6c38ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c38ac",
  null
  
)

export default component.exports